import {
  LanguageCode,
  ManagedFilter,
} from '../../graphql/generated/generated-types';

export class EditableFilters {
  constructor(
    public top: EditableManagedFilter[] = [],
    public left: EditableManagedFilter[] = []
  ) {}
  static adapt(item: any): EditableFilters {
    return new EditableFilters(item.top || [], item.left || []);
  }

  updateTop(newTop: EditableManagedFilter[] | ManagedFilter[]): void {
    // creating deep copies, so managedFilter types would not follow up
    this.top = JSON.parse(JSON.stringify(newTop)) as EditableManagedFilter[];
  }

  updateLeft(newLeft: EditableManagedFilter[] | ManagedFilter[]): void {
    // creating deep copies, so managedFilter types would not follow up
    this.left = JSON.parse(JSON.stringify(newLeft)) as EditableManagedFilter[];
  }
}
export class EditableManagedFilter {
  constructor(
    public __typename: any,
    public code: string,
    public id: any,
    public languageCode: LanguageCode,
    public name: string,
    public values: EditableManagedFilter[],
    public count?: number
  ) {}

  static adapt(item: any): EditableManagedFilter {
    return new EditableManagedFilter(
      item.__typename,
      item.code,
      item.id,
      item.languageCode,
      item.name,
      item.values,
      item.count
    );
  }
}

export class EditableManagedFilterValue {
  constructor(
    public __typename: any,
    public code: string,
    public id: any,
    public languageCode: LanguageCode,
    public name: string,
    public filterId: string,
    public count?: number
  ) {}

  static adapt(item: any): EditableManagedFilterValue {
    return new EditableManagedFilterValue(
      item.__typename,
      item.code,
      item.id,
      item.languageCode,
      item.name,
      item.filterId,
      item.count
    );
  }
}
